<div class="maia-chat-panel" data-testid="maia-chat-panel">

    <!-- <header class="chat-header">
        <span class="chat-title">MAIA</span>
        <button type="button"
                class="exit-button"
                data-testid="maia-exit-button"
                (click)="exitRequested.emit()">
            Exit
        </button>
    </header> -->

    <div class="chat-body" data-testid="maia-chat-body">
        <div class="message-row">
            <span class="avatar" aria-hidden="true">M</span>
            <div class="bubble">
                <span class="bubble-author">MAIA</span>
                <p class="bubble-text">{{ greeting }}</p>
            </div>
        </div>

        <button type="button"
                class="suggestion-button"
                data-testid="maia-upload-new-sov-button"
                (click)="uploadRequested.emit()">
            Upload new SOV file
        </button>

        <div class="message-row"
             *ngFor="let message of messages"
             [class.message-row--user]="message.role === MaiaChatRole.USER">
            <span class="avatar" aria-hidden="true">{{ message.role === MaiaChatRole.USER ? 'U' : 'M' }}</span>
            <div class="bubble">
                <span class="bubble-author">{{ message.role === MaiaChatRole.USER ? 'You' : 'MAIA' }}</span>
                <p class="bubble-text">{{ message.text }}</p>
            </div>
        </div>

        <div class="message-row" *ngIf="sending" data-testid="maia-chat-typing">
            <span class="avatar" aria-hidden="true">M</span>
            <div class="bubble">
                <span class="bubble-author">MAIA</span>
                <p class="bubble-text bubble-text--typing">Thinking…</p>
            </div>
        </div>

        <p class="chat-error" *ngIf="errorMessage" data-testid="maia-chat-error">{{ errorMessage }}</p>
    </div>

    <footer class="chat-footer">
        <div class="composer">
            <input type="text"
                   class="composer-input"
                   data-testid="maia-chat-input"
                   placeholder="Ask MAIA to help with your upload…"
                   [(ngModel)]="draft"
                   [disabled]="sending"
                   (keydown.enter)="send()"/>
            <button type="button"
                    class="send-button"
                    data-testid="maia-chat-send-button"
                    aria-label="Send message"
                    [disabled]="!draft.trim() || sending"
                    (click)="send()">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                    <path d="M21.5 12 3.5 4.5l3 7.5-3 7.5z"
                          stroke="currentColor"
                          stroke-width="1.6"
                          stroke-linejoin="round"/>
                </svg>
            </button>
        </div>
    </footer>

</div>
